import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function AboutVision() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px] overflow-hidden" data-id="element-128">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-129">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-130">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" data-id="element-131">
            <div className="relative mx-auto max-w-[400px] lg:max-w-none" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/sJBEdPwnCiw3TEJMeAJisd/Group_196.png" alt="Clinical aesthetic setting" className="w-full h-[300px] lg:h-[500px] object-cover rounded-lg shadow-xl" data-id="element-133" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%] text-center lg:text-left" delay={200} data-id="element-134">
            <span className="text-white uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-135">
              OUR VISION
            </span>

            <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-136">
              VISION BEHIND THE BRAND
            </h2>

            <div className="space-y-6 text-white text-base leading-[1.7] font-body" data-id="element-137">
              <p data-id="element-138">
                The vision behind the Be CLINICAL brand originates from the
                science, evidence, and results-based approach that Dr. Frie and
                her team bring to their medical and aesthetics practice.
              </p>
              <p data-id="element-139">
                More patients are experiencing anxiety around getting older &
                maintaining the perfect body—the pressure to age well is at an
                all time high. As the aesthetic industry continues to grow there
                is more confusion around what is safe, effective, and worth the
                investment.
              </p>
              <p className="font-bold italic text-lg mt-8" data-id="element-140">
                To that we say…don't worry, Be CLINICAL about it!
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}